export enum NodeStatus {
	Unknown,
	Asleep,
	Awake,
	Dead,
	Alive,
}
